import script from "./RubricList.vue?vue&type=script&setup=true&lang=js"
export * from "./RubricList.vue?vue&type=script&setup=true&lang=js"

import "./RubricList.vue?vue&type=style&index=0&id=09d77684&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d77684"]])

export default __exports__